import { __assign } from "tslib";
import { DOM_EVENT, generateUUID, getTimestamp, monitor, msToNs, throttle } from '@datadog/browser-core';
import { LifeCycleEventType } from './lifeCycle';
import { RumEventCategory } from './rum';
export var viewContext;
var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var startOrigin;
var documentVersion;
var viewMeasures;
export function trackView(location, lifeCycle, session, upsertRumEvent, beforeFlushOnUnload) {
    var scheduleViewUpdate = throttle(monitor(function () { return updateView(upsertRumEvent); }), THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    });
    newView(location, session, upsertRumEvent);
    trackHistory(location, session, upsertRumEvent);
    trackMeasures(lifeCycle, scheduleViewUpdate);
    trackRenewSession(location, lifeCycle, session, upsertRumEvent);
    beforeFlushOnUnload(function () { return updateView(upsertRumEvent); });
}
function newView(location, session, upsertRumEvent) {
    startOrigin = !viewContext ? 0 : performance.now();
    viewContext = {
        id: generateUUID(),
        location: __assign({}, location),
        sessionId: session.getId(),
    };
    documentVersion = 1;
    viewMeasures = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0,
    };
    upsertViewEvent(upsertRumEvent);
}
function updateView(upsertRumEvent) {
    documentVersion += 1;
    upsertViewEvent(upsertRumEvent);
}
function upsertViewEvent(upsertRumEvent) {
    upsertRumEvent({
        date: getTimestamp(startOrigin),
        duration: msToNs(performance.now() - startOrigin),
        evt: {
            category: RumEventCategory.VIEW,
        },
        rum: {
            documentVersion: documentVersion,
        },
        view: {
            measures: viewMeasures,
        },
    }, viewContext.id);
}
function trackHistory(location, session, upsertRumEvent) {
    var originalPushState = history.pushState;
    history.pushState = monitor(function () {
        originalPushState.apply(this, arguments);
        onUrlChange(location, session, upsertRumEvent);
    });
    var originalReplaceState = history.replaceState;
    history.replaceState = monitor(function () {
        originalReplaceState.apply(this, arguments);
        onUrlChange(location, session, upsertRumEvent);
    });
    window.addEventListener(DOM_EVENT.POP_STATE, monitor(function () {
        onUrlChange(location, session, upsertRumEvent);
    }));
}
function onUrlChange(location, session, upsertRumEvent) {
    if (areDifferentViews(viewContext.location, location)) {
        updateView(upsertRumEvent);
        newView(location, session, upsertRumEvent);
    }
}
function areDifferentViews(previous, current) {
    return previous.pathname !== current.pathname;
}
function trackMeasures(lifeCycle, scheduleViewUpdate) {
    lifeCycle.subscribe(LifeCycleEventType.PERFORMANCE_ENTRY_COLLECTED, function (entry) {
        if (entry.entryType === 'navigation') {
            var navigationEntry = entry;
            viewMeasures = __assign(__assign({}, viewMeasures), { domComplete: msToNs(navigationEntry.domComplete), domContentLoaded: msToNs(navigationEntry.domContentLoadedEventEnd), domInteractive: msToNs(navigationEntry.domInteractive), loadEventEnd: msToNs(navigationEntry.loadEventEnd) });
            scheduleViewUpdate();
        }
        else if (entry.entryType === 'paint' && entry.name === 'first-contentful-paint') {
            var paintEntry = entry;
            viewMeasures = __assign(__assign({}, viewMeasures), { firstContentfulPaint: msToNs(paintEntry.startTime) });
            scheduleViewUpdate();
        }
    });
    lifeCycle.subscribe(LifeCycleEventType.ERROR_COLLECTED, function () {
        viewMeasures.errorCount += 1;
        scheduleViewUpdate();
    });
    lifeCycle.subscribe(LifeCycleEventType.USER_ACTION_COLLECTED, function () {
        viewMeasures.userActionCount += 1;
        scheduleViewUpdate();
    });
    lifeCycle.subscribe(LifeCycleEventType.PERFORMANCE_ENTRY_COLLECTED, function (entry) {
        if (entry.entryType === 'longtask') {
            viewMeasures.longTaskCount += 1;
            scheduleViewUpdate();
        }
    });
    lifeCycle.subscribe(LifeCycleEventType.RESOURCE_ADDED_TO_BATCH, function () {
        viewMeasures.resourceCount += 1;
        scheduleViewUpdate();
    });
}
function trackRenewSession(location, lifeCycle, session, upsertRumEvent) {
    lifeCycle.subscribe(LifeCycleEventType.SESSION_RENEWED, function () {
        updateView(upsertRumEvent);
        newView(location, session, upsertRumEvent);
    });
}
//# sourceMappingURL=viewTracker.js.map